const binding = { modules: {}, dataActions: {} };

    (binding.modules['dlvry-authenticated-container'] = {
        c: () => require('partner/modules/dlvry-authenticated-container/dlvry-authenticated-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dlvry-authenticated-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dlvry-authenticated-container'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };